const { useI18n } = require('@fegobull/webapi').use;
import { ELang } from '@ark/utils';

type I18nDict = Record<string, unknown>;

// D-32:sites=['US'] 仅英文;CN 空对象占位防 runtime 报错,不标 TODO 避免污染 fallback
// D-33:key 命名规则 amoe.form.{field}.{label|placeholder|error.*} / amoe.sms.* /
// amoe.picker.* / amoe.result.{kind}.{title|message|cta} / amoe.errors.{code}
export const AMOE_I18N_DICT = {
  amoe: {
    form: {
      firstName: {
        label: 'First Name',
        placeholder: 'Enter first name',
        error: {
          required: 'This field is required.',
          invalid: 'Please enter a valid name.',
          maxLength: 'Please enter 100 characters or fewer.',
        },
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Enter last name',
        error: {
          required: 'This field is required.',
          invalid: 'Please enter a valid name.',
          maxLength: 'Please enter 100 characters or fewer.',
        },
      },
      age: {
        label: 'Age',
        placeholder: 'Enter age',
        error: {
          required: 'This field is required.',
          invalid: 'You must be 18 or older to participate.',
        },
      },
      countryCode: {
        label: 'Country Code',
        placeholder: 'Select country code',
        error: {
          required: 'This field is required.',
          maxLength: 'Please enter 10 characters or fewer.',
        },
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Enter phone number',
        error: {
          required: 'This field is required.',
          invalid: 'Please enter a valid phone number.',
          maxLength: 'Please enter 50 characters or fewer.',
        },
      },
      addressLine1: {
        label: 'Address 1',
        placeholder: 'Enter address 1',
        error: {
          required: 'This field is required.',
          invalid: 'Please enter a valid address.',
          maxLength: 'Please enter 255 characters or fewer.',
        },
      },
      addressLine2: {
        label: 'Address 2',
        placeholder: 'Enter address 2 (optional)',
        error: {
          maxLength: 'Please enter 255 characters or fewer.',
        },
      },
      city: {
        label: 'City',
        placeholder: 'Enter city',
        error: {
          required: 'This field is required.',
          invalid: 'Please enter a valid city name.',
          maxLength: 'Please enter 100 characters or fewer.',
        },
      },
      state: {
        label: 'State/Province',
        placeholder: 'Select state',
        error: {
          required: 'This field is required.',
          blocked: 'Residents of this state are not eligible to participate.',
          maxLength: 'Please enter 50 characters or fewer.',
        },
      },
      zipCode: {
        label: 'Zip/Postal Code',
        placeholder: 'Enter zip/postal code',
        error: {
          required: 'This field is required.',
          invalid: 'Please enter a valid ZIP/postal code.',
          maxLength: 'Please enter 20 characters or fewer.',
        },
      },
      email: {
        label: 'Email Address',
        placeholder: 'Enter email address',
        error: {
          required: 'This field is required.',
          invalid: 'Please enter a valid email address.',
          maxLength: 'Please enter 255 characters or fewer.',
        },
      },
      smsCode: {
        label: 'SMS Verification Code',
        placeholder: 'Enter SMS code',
        error: {
          required: 'Please enter the verification code.',
          maxLength: 'Please enter 10 characters or fewer.',
        },
      },
      submit: {
        // D-38:统一 'Submit',不随状态切换
        label: 'Submit',
      },
      agreement: {
        // 运行时按 '{tos}' / '{privacy}' 模板拆渲染,组件用 span 分段
        label: 'I have read and agree to the {tos} and {privacy}.',
        tos: 'Terms and Conditions',
        privacy: 'Privacy Policy',
      },
    },
    sms: {
      sendBtn: 'Send',
      cooldown: 'Resend in {n}s',
      sent: 'Sent',
    },
    picker: {
      countryCode: {
        title: 'Select country code',
        searchPlaceholder: 'Search',
      },
      state: { title: 'Select state', searchPlaceholder: 'Search' },
      cancel: 'Cancel',
      empty: 'No results found',
    },
    result: {
      // idle / submitting 不渲染 modal,无 key
      deliveryLoading: {
        title: 'Processing your entry...',
        message: 'Please wait a moment.',
      },
      won: {
        title: 'Congratulations!',
        message:
          "You've won {prizeName}. We'll email you the details within 3 business days.",
        cta: 'Explore more',
      },
      lost: {
        title: 'Better luck next time',
        message: 'Thanks for entering. Come back for the next round.',
        cta: 'Close',
      },
      alreadyMoomoo: {
        title:
          'Your AMOE phone number or email is already linked to a moomoo account.',
        message: 'Please log in to join on the promotion page.',
        cta: 'Got it',
      },
      duplicate: {
        title: 'The phone number or email you entered has already been used.',
        message:
          'Please log in to your moomoo account to participate in the next Victory Game on the promotion page.',
        cta: 'Got it',
      },
      ipRejected: {
        title: 'Your current region is not eligible for this promotion.',
        message: 'Please join from an eligible region on the promotion page.',
        cta: 'Got it',
      },
      noRound: {
        notStarted: {
          title: "The giveaway hasn't started",
          message: 'Come back when the next round opens.',
        },
        ended: {
          title: 'The giveaway has ended',
          message: 'Thanks for your interest. Stay tuned for the next round.',
        },
        empty: {
          title: 'No active round right now',
          message: 'Please check back soon for the next round.',
        },
        submitHint: 'No round available to enter.',
      },
      seasonSignMissing: {
        title: 'This giveaway is not available',
        message:
          'The giveaway has not been set up yet. Please try again later.',
      },
    },
    errors: {
      // SMS 平台错误(D-26 后端转译 -72xx)
      '31021': 'Please wait before requesting another code.',
      '31022': 'Too many attempts. Please request a new code.',
      '31023': 'Code expired. Please request a new one.',
      '31024': 'Incorrect verification code. Please try again.',
      '31025': "We couldn't send the code. Please try again.",
      // Submit 业务错误(31031-33 走 state kind 映射,此处作为 fallback 文案)
      '31031': 'You already have a moomoo account.',
      '31032': "You've already entered this round.",
      '31033': 'Not eligible in your region.',
      '31041': 'No active round available right now.',
      network: 'Something went wrong. Please try again later.',
    },
  },
} as const;

const $t = useI18n({
  [ELang.KV.CN]: {},
  [ELang.KV.EN]: AMOE_I18N_DICT,
});

/**
 * AMOE 只维护英文文案。
 *
 * FEGO 运行态语言码落到 CN 或 key 未命中时，useI18n 可能直接返回 key；
 * 这里统一回查英文 dict，避免页面露出 amoe.xxx。
 */
function translate(path: string): string {
  const value = $t(path);
  if (value !== path) return value;

  const fallback = path.split('.').reduce<unknown>((current, segment) => {
    if (!current || typeof current !== 'object') return undefined;
    return (current as I18nDict)[segment];
  }, AMOE_I18N_DICT);

  return typeof fallback === 'string' ? fallback : path;
}

export default translate;
